// ErrorOptions is a built-in interface from lib.es2022.error
export class SelfServiceError extends Error {
  constructor(...params: any) {
    super(...params);
    // Ensure correct prototype chain across runtimes
    Object.setPrototypeOf(this, new.target.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SelfServiceError);
    }
    this.name = 'SelfServiceError';
  }

  static fromMissingProperty(property: string, expectedType: string, value: unknown): SelfServiceError {
    return new SelfServiceError(
      `Required property \`${property}\` was invalid. Expected ${expectedType}, got ${typeof value}`
    );
  }

  static fromInvalidProperty(property: string, value: unknown): SelfServiceError {
    return new SelfServiceError(`Invalid property \`${property}\` with value ${value}`);
  }
}

export default SelfServiceError;
